// Markdown till HTML för Spotlight-artiklar, plus en hjälpare som bygger en
// kort SEO-beskrivning ur en artikelkropp när ingressen saknas.
//
// Kommentaren här sa tidigare "safe defaults" och att ingen rå HTML slapp
// igenom. Det var fel. `marked` släpper igenom rå HTML som standard, och
// saneringsflaggan togs bort ur biblioteket i version 5. Utdatan sätts med
// dangerouslySetInnerHTML på en publik sida, så ett skript i artikeltexten
// kördes i besökarens webbläsare på talentsio.com.
//
// Servern sanerar nu vid sparandet, i markdown_policy.py. Den här filen
// sanerar utdatan också: det som redan ligger i databasen har aldrig passerat
// serverns kontroll, och en kommentar som lovar en sanering ska ha en sanering
// bakom sig.
import { marked } from "marked";
import { sanitizeHtml } from "./sanitizeHtml";

marked.setOptions({
  gfm: true,
  breaks: true,
});

export function renderMarkdown(md) {
  if (!md) return "";
  try {
    return sanitizeHtml(marked.parse(md, { async: false }));
  } catch {
    return "";
  }
}

export function stripMarkdown(md, maxChars = 180) {
  if (!md) return "";
  const plain = md
    .replace(/```[\s\S]*?```/g, " ")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/!\[[^\]]*\]\([^)]*\)/g, " ")
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/[#*_>\-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return plain.length > maxChars ? plain.slice(0, maxChars - 1).trim() + "…" : plain;
}
